export const summaryRows: string[] = [
  'Tomo 1 — Fundamentos de la Energía Nuclear',
  'Tomo 2 — Radiactividad y Radiación Ionizante',
  'Tomo 3 — Fisión Nuclear y Producción de Energía',
  'Tomo 4 — Reactores y Centrales Nucleares',
  'Tomo 5 — Seguridad Nuclear y Protección Radiológica',
  'Tomo 6 — Combustible Nuclear y Gestión de Residuos Radiactivos',
  'Tomo 7 — Aplicaciones de la Tecnología Nuclear en Medicina, Industria, Agricultura y Ciencia',
  'Tomo 8 — Energía Nuclear, Ambiente y Desarrollo Sostenible',
  'Tomo 9 — Enseñanza de la Energía Nuclear: Estrategias, Actividades y Propuestas para el Aula',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones',
  'Bono 4 — 100 Proyectos, Debates y Propuestas',
  'Bono 5 — Guía de Conceptos, Glosario y Mitos',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];
